import React from "react"
import GDProjectName from "../../../../../gd-ui/project-name/project-name"
import {FieldViewPropertyProps} from "../../../../render/view-property"
import BreadcrumbsUI5 from "../../../../../gd-components/breadcrumbs/breadcrumbs-ui5"
import {FieldProject_ViewType} from "./view"

export default function FieldProject_ViewProperty(props: FieldViewPropertyProps) {

    const value = props.field.getViewValue(props.model)

    switch (props.params?.viewType) {
        case FieldProject_ViewType.FULL_PATH: {
            const showIcon   = _.get(props.params, 'showIcon', false)
            const maxParents = _.get(props.params, 'maxParents', 3)
            const colorize   = _.get(props.params, 'colorize', false)

            return (
                <BreadcrumbsUI5
                    className       = {Classes("ui5-prop gray", props.className)}
                    style           = {props.style}
                    projectId       = {value}
                    maxParents      = {maxParents}
                    showIcon        = {showIcon}
                    colorize        = {colorize}
                    hintFullPath    = {true}
                    disabled        = {true}
                />
            )
        }

        case FieldProject_ViewType.PROPERTY:
        default: {
            return (
                <GDProjectName
                    className       = {props.className}
                    style           = {props.style}
                    type            = "ui5-prop"
                    projectId       = {value}
                    hintFullPath    = {true}
                    onClick         = {props.onClick}
                />
            )
        }
    }

}
